import Growth from "../../models/Growth";

const valuesData: Growth[] = [
  {
    title: "Formations en management",
    items: [
      "Renforcez vos compétences clés et celles de vos collaborateurs",
      "Optimisez votre posture managériale",
      "Utilisez la dynamique de groupe",
      "Gérez les personnalités et la motivation",
      "Managez les situations de crise",
      "Développez votre posture et votre communication",
      "Optimisez le temps",
      "Utilisez l’intelligence collective et émotionnelle"
    ]
  },
  {
    title:
      "Coaching professionnel en transition de carriere & posture manageriale",
    items: [
      "Assurez vos prises de décisions",
      "Accélérez votre transition de carrière",
      "Valorisez et développer vos compétences individuelles et celles de vos équipes",
      "Franchissez de nouvelles étapes de votre évolution professionnelle"
    ]
  },
  {
    title: "Conseil en organisation",
    items: [
      "Optimisez la structure et les processus de votre entreprise",
      "Développez la cohésion d’équipe",
      "Fluidifiez les circuits de l’information",
      "Donnez vie et pertinence à vos process",
      "Développez la créativité de votre environnement"
    ]
  },
  {
    title: "Bilan de competences",
    items: [
      "Bénéficiez d’une analyse de vos connaissances et compétences professionnelles et personnelles et de vos intérêts/ Auto Evaluation via des outils",
      "Identifiez vos aptitudes et vos motivations pour développer un nouveau projet professionnel et/ ou un projet de formation dans le champ de vos possibles",
      "Définissez et mettez en œuvre du projet professionnel avec les objectifs et le suivi des réalisations",
      "Harmonisez vos transitions de compétences"
    ]
  }
];

export default valuesData;
